import React from 'react';
import {
  List,
  TextInput,
  SelectInput,
  ReferenceInput,
  translate as t,
  Filter,
  Datagrid,
  TextField,
  BooleanField,
} from 'admin-on-rest';

import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import { getTranslationByLocale } from '../utils/TranslationUtils';

const FrozenProductFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Category"
      source="category"
      reference="categories"
      perPage={9999}
      allowEmpty
      alwaysOn
    >
      <SelectInput optionText={<Title {...props} />} />
    </ReferenceInput>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const FrozenProductList = (props) => (
  <List
    {...props}
    filters={<FrozenProductFilter />}
    filter={{
      frozen: true,
    }}
    perPage={20}
  >
    <Datagrid>
      <TextField source="internalName" />
      <BooleanField source="frozen" />
      <BooleanField source="provisional" />
      <EditButton {...props} path="/products" property="code" />
      <DeleteButton {...props} path="/products" property="code" />
    </Datagrid>
  </List>
);

const Title = t(({ record, locale }) =>
  getTranslationByLocale(record.title, locale)
);
